export default __webpack_public_path__ + "static/media/Bitmap_8.74571884.jpg";